import axios from 'axios'
import { toArray, merge } from 'lodash'
import moment from 'moment'
import router from '../../../spa/src/router/router.js'
import { ADDON_PRODUCT_IMPRESSION_EVENT } from "../../utilities/constants";

// state
const state = {
  parentOrderId: '',
  currentTime: '',
  currentTimeTimeoutId: 0,
  expiration: {},
  orderAddOn: {
    parentOrderId: '',
    priceInfo: {
      subTotal: {}
    },
    store: {
      name: '',
      id: ''
    },
    timeslot: {},
    commerceItems: [],
    remainingAddOnItems: -1,
    maxAddOnItems: -1
  },
  curbsideFulfillmentMode: {},
  upsells: {
    featuredProductRecommendations: [],
    forgottenProductRecommendations: [],
    suggestedProductRecommendations: [],
    frequentlyPurchasedProductRecommendations: []
  },
  searchParams: {
    q: '',
    Nf: '',
    Ns: '',
    N: [],
    prodFilter: 'none',
    No: 0,
    Nrpp: 32
  },
  searchResults: {
    categories: [],
    products: [],
    numberOfProducts: null,
    searchTerm: '',
    dimensionList: []
  },
}

const getters = {
  getStoreId: state => state.orderAddOn.store.id,
  searchParamsForQueryString: (state) => {
    // This translates state.searchParams into the required format for a queryString since you can have an array in a URL

    function cleanNandMakeString(N) {
      // N can be an array, %20 separated string, or space separated string
      // Lets clean it up and turn it into a URI compliant %20 separated string

      // Make into array if it isn't
      if (typeof N === 'string') {
        N = N.replace(/ /g, '%20')
        N = N.split('%20')
      }

      //Make into string for query
      N = N.join(' ')

      return N
    }

    var searchParamsForQueryString = {
      q: state.searchParams.q, // Search Query
      storeId: state.orderAddOn.store.id, // StoreId Required for Pricing
      prodFilter: state.searchParams.prodFilter,
      N: cleanNandMakeString(state.searchParams.N), // These are '%20' (encoded space) delineated values. They apply dimension refinements, or lifestyle/brand refinements.
      Ns: state.searchParams.Ns, // Sort By
      Nf: state.searchParams.Nf, // Price Range
      Nrpp: state.searchParams.Nrpp, // 	This overrides the default configuration for the ProductResultsList to return more or less products.
      No: state.searchParams.No, // 	This is the offset value for moving forward or backwards in the product list.
      exp: state.searchParams.exp // Sets fulfillment channel: cspview | csdview | sthview | instoreview
    }

    return searchParamsForQueryString
  },
  addOnSubstitutions: state => {
    return state.orderAddOn.substitutionsAllowAll;
  },
  addOnSubstitutionsEnabled: state => state.orderAddOn.substitutionPreferenceEnabled,
}

const actions = {
  GET_ADD_ONS({ COMMIT }, parentOrderId) {
    var vm = this
    vm.commit('orderAddOns/SET_PARENT_ORDER_ID', parentOrderId)
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.get('/commerce-api/v1/addon/' + parentOrderId + '/full')
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
          vm.commit('orderAddOns/UPDATE_EXPIRATION', response.data.currentTime)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  POST_ADD_ONS({ COMMIT, state }, parentOrderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.post('/commerce-api/v1/addon/submit/' + parentOrderId)
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
          const successQueryParams = `success=OK&itemCount=${response.data.totalCommerceItemCount}`;
          const redirectUrl = `/my-account/order-history/${parentOrderId}?${successQueryParams}`;
          window.location.assign(redirectUrl);
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  GET_FEATURED_PRODUCT_RECOMMENDATIONS({ COMMIT }, orderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.get('/commerce-api/v1/addon/upsell/featuredProductRecommendations', {
          params: {
            parentOrderId: orderId
          }
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_FEATURED_PRODUCT_RECOMMENDATIONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  GET_FORGOTTEN_PRODUCT_RECOMMENDATIONS({ COMMIT }, orderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.get('/commerce-api/v1/addon/upsell/forgottenProductRecommendations', {
          params: {
            parentOrderId: orderId
          }
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_FORGOTTEN_PRODUCT_RECOMMENDATIONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  GET_SUGGESTED_PRODUCT_RECOMMENDATIONS({ COMMIT }, orderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.get('/commerce-api/v1/addon/upsell/suggestedProductRecommendations', {
          params: {
            parentOrderId: orderId
          }
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_SUGGESTED_PRODUCT_RECOMMENDATIONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  GET_FREQUENTLY_PURCHASED_PRODUCT_RECOMMENDATIONS({ COMMIT }, orderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.get('/commerce-api/v1/addon/upsell/frequentlyPurchasedProductRecommendations', {
          params: {
            parentOrderId: orderId
          }
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_FREQUENTLY_PURCHASED_PRODUCT_RECOMMENDATIONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  GET_SEARCH_RESULTS({ COMMIT }, searchQuery) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')
    vm.commit('loading/SET_LOADING', true)

    axios
      .all([
        axios.get('/rest/model/atg/commerce/catalog/ProductCatalogActor/searchProducts', {
          params: vm.getters['orderAddOns/searchParamsForQueryString']
        })
      ])
      .then(
        axios.spread((response) => {

          // Add checked flag so the frontend can know which dimensions have been selected.
          var dimensionsWithN = response.data.contents.dimensionList.filter(dimension => dimension.dimensionParam === 'N');

          dimensionsWithN.forEach(function (dimension) {

            dimension.refinements.forEach(function (refinement) {
              if (vm.state.orderAddOns.searchParams.N.indexOf(refinement.refinementId) > -1) {
                refinement['checked'] = true
              } else {
                refinement['checked'] = false
              }
            })

          })

          vm.commit('orderAddOns/SET_SEARCH_RESULTS', response.data)
          vm.commit('loading/SET_LOADING', false)
          if (searchQuery.triggerGtm) {
            vm.commit('orderAddOns/PUSH_GTM_PAGE_TRACKING', response.data)
          }
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
        vm.commit('loading/SET_LOADING', false)
      })
  },
  GET_TYPEAHEAD_SUGGESTIONS({ COMMIT }, searchTerm) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    return axios
      .all([
        axios.get('/commerce-api/v1/search/typeAhead?searchTerm=' + searchTerm)
      ])
      .then(
        axios.spread((response) => {
          return response.data.suggestions
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', { message: error.response.data.title, code: error.response.status })
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', { message: 'Couldn\'t contact the website' })
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', { message: error.message })
        }
        console.log(error.config)
      })
  },
  UPDATE_SEARCH_PARAMS({ commit }, params) {
    // remove UPDATE_SEARCH_PARAMS this is sync
    return new Promise((resolve, reject) => {
      commit('SET_SEARCH_PARAMS', params)
      resolve()
    })
  },
  ADD_ITEM_TO_BUCKET({ COMMIT }, item) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    /**
     * Adds an item to the order. The `item` object should look like this
     * item: {
     *   productId: '6456',
     *   skuId: '61678',
     *   quantity: 1,
     *   orderId: 'HEB40870004'
     *   note: '' // optional
     * }
     */

    if (window.location.href.indexOf("orderconfirmation") > -1) {
      return axios
        .all([
          axios.post('/commerce-api/v1/addon/' + vm.state.cart.id + '/item', item)
        ])
        .then(
          axios.spread((response) => {
            window.location.assign('/my-account/order-history/add-on/' + vm.state.cart.id)
          })
        )
        .catch((error) => {
          // Error
          if (error.response) {
            vm.commit('errors/PUSH_ERROR', { message: error.response.data.title, code: error.response.status })
          } else if (error.request) {
            vm.commit('errors/PUSH_ERROR', { message: 'Couldn\'t contact the website' })
            console.log(error.request)
          } else {
            console.log('Error', error.message)
            vm.commit('errors/PUSH_ERROR', { message: error.message })
          }
          console.log(error.config)
        })
    } else {
      return axios
        .all([
          axios.post('/commerce-api/v1/addon/' + vm.state.orderAddOns.parentOrderId + '/item', item)
        ])
        .then(
          axios.spread((response) => {
            vm.commit('orderAddOns/SET_ADD_ONS', response.data)
            return response
          })
        )
        .catch((error) => {
          // Special Case: Swallow maximumOrderQuantity since it is displayed inline
          if (_.get(error, "response.data.errors[0]['o:errorCode']", false) === "error.maximumOrderQuantity") {
            return error.response;
          }

          // Error
          if (error.response) {
            const msg = error.response.data.title;
            vm.commit('errors/PUSH_ERROR', { message: msg, code: error.response.status })
          } else if (error.request) {
            vm.commit('errors/PUSH_ERROR', { message: 'Couldn\'t contact the website' })
            console.log(error.request)
          } else {
            console.log('Error', error.message)
            vm.commit('errors/PUSH_ERROR', { message: error.message })
          }
          return error.response;
        })
    }
  },
  PUT_ITEM_QUANTITY({ COMMIT }, item) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    const currentItemQty = vm.state.orderAddOns.orderAddOn.commerceItems.find(commerceItem => commerceItem.id === item.id).quantity
    let itemQty = item.quantity

    /* COMMENTED OUT BECAUSE IT WAS BREAKING ADDONS WHEN ADDON LIMITS WERE INTRODUCED, PLEASE REVISIT POST COVID-19 */
    /* if (itemQty >= vm.state.orderAddOns.orderAddOn.remainingAddOnItems && itemQty > currentItemQty && vm.state.orderAddOns.orderAddOn.remainingAddOnItems != -1) {
      itemQty = currentItemQty + vm.state.orderAddOns.orderAddOn.remainingAddOnItems
    } */

    /* THE INCREMENTAL FLAG SHOULD BE SET TO FALSE HERE SINCE IT DEFAULTS TO TRUE BUT IT DOESN'T SEEM TO VALIDATE PROPERLY */
    var body = {
      parentOrderId: vm.state.orderAddOns.parentOrderId,
      quantity: itemQty
    }

    return axios
      .all([
        axios.put('/commerce-api/v1/addon/item/' + item.id + '/quantity', body)
      ])
      .then(
        axios.spread(response => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
          return response
        })
      )
      .catch(error => {
        // Special Case: Swallow maximumOrderQuantity since it is displayed inline
        if (_.get(error, "response.data.errors[0]['o:errorCode']", false) === "error.maximumOrderQuantity") {
          return error.response;
        }

        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', { message: error.response.data.title, code: error.response.status })
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', { message: 'Couldn\'t contact the website' })
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', { message: error.message })
        }

        return error.response;
      })
  },
  DELETE_ADD_ONS({ COMMIT, state }, parentOrderId) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')

    axios.all([
      axios.delete('/commerce-api/v1/addon/' + parentOrderId)
    ]).then(
      axios.spread(() => {
        const redirectUrl = `/my-account/order-history/${parentOrderId}`;
        window.location.assign(redirectUrl);
      })
    ).catch((error) => {
      vm.dispatch('errors/HANDLE_ERROR', error)
    })
  },
  PUT_ITEM_NOTE({ COMMIT }, item) {
    var vm = this

    axios
      .all([
        axios.put('/commerce-api/v1/addon/item/' + item.id + '/note', {
          note: item.note.note.substring(0, 255),
          parentOrderId: vm.state.orderAddOns.parentOrderId
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
        })
      ).catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  PUT_ORDER_SUBSTITUTION({ COMMIT }, boolean) {
    var vm = this

    axios
      .all([
        axios.put('/commerce-api/v1/addon/substitution/', {
          allowed: boolean,
          parentOrderId: vm.state.orderAddOns.parentOrderId
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
        })
      ).catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  PUT_ITEM_SUBSTITUTION({ COMMIT }, item) {
    var vm = this

    axios
      .all([
        axios.put('/commerce-api/v1/addon/item/' + item.id + '/substitution', {
          allowed: item.allowSubstitution,
          parentOrderId: vm.state.orderAddOns.parentOrderId
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  },
  DELETE_ITEM({ COMMIT }, id) {
    var vm = this

    return axios
      .all([
        axios.delete('/commerce-api/v1/addon/item/' + id, {
          params: {
            parentOrderId: vm.state.orderAddOns.parentOrderId
          }
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('orderAddOns/SET_ADD_ONS', response.data)
        })
      )
      .catch((error) => {
        vm.dispatch('errors/HANDLE_ERROR', error);
        return error.response;
      })
  }
}

const mutations = {
  SET_PARENT_ORDER_ID(state, data) {
    state.parentOrderId = data
  },
  SET_ADD_ONS({ state }, data) {
    // state.orderAddOn = data

    // Modify data to include substitutions
    data.substitutionsAllowAll = true

    // Modify data of each commerceItem
    data.commerceItems.map((item) => {
      // Add item notes
      item.note = {
        note: item.itemNote || '',
        isEditing: false
      }

      // Add item substitutions preference
      item.allowSubstitution = item.allowSubstitution !== false

      if (item.substitutionPreferenceEnabled && item.allowSubstitution === false) {
        data.substitutionsAllowAll = false
      }

      // frontend isDiscounted flag
      if (
        item.priceInfo.totalAmount.amount !==
        item.priceInfo.rawTotalPrice.amount
      ) {
        item.priceInfo.isDiscounted = true;
      } else {
        item.priceInfo.isDiscounted = false;
      }
    })

    this._vm.$set(this.state.orderAddOns, 'orderAddOn', data)
  },
  SET_FEATURED_PRODUCT_RECOMMENDATIONS({ state }, data) {
    this._vm.$set(this.state.orderAddOns.upsells, 'featuredProductRecommendations', data.productItems)
  },
  SET_FORGOTTEN_PRODUCT_RECOMMENDATIONS({ state }, data) {
    this._vm.$set(this.state.orderAddOns.upsells, 'forgottenProductRecommendations', data.productItems)
  },
  SET_SUGGESTED_PRODUCT_RECOMMENDATIONS({ state }, data) {
    this._vm.$set(this.state.orderAddOns.upsells, 'suggestedProductRecommendations', data.productItems)
  },
  SET_FREQUENTLY_PURCHASED_PRODUCT_RECOMMENDATIONS({ state }, data) {
    this._vm.$set(this.state.orderAddOns.upsells, 'frequentlyPurchasedProductRecommendations', data.productItems)
  },
  SET_SEARCH_PARAMS(state, params) {
    let N
    if (params.N === '' || params.N === undefined) {
      N = []
    } else if (typeof params.N === 'string') {
      N = params.N.split(' ')
    } else {
      N = params.N
    }

    params.exp = (state.orderAddOn.curbsideFulfillmentMode === 'pickup') ? 'cspview' : 'csdview'

    state.searchParams = {
      ...state.searchParams,
      ...params,
      N: N
    }
  },
  SET_SEARCH_RESULTS(state, data) {
    state.searchResults = data.contents
  },
  PUSH_GTM_PAGE_TRACKING(state, data) {
    //gives you the current page based on the starting number of the products on the page / the number of products to display on the page
    let currentPage = Math.ceil(state.searchParams.No / state.searchParams.Nrpp) + 1
    let dimenstionList = toArray(state.searchParams.N).join(' ')
    let dimensionsFiltered = data.contents.dimensionList.filter(dimension => dimension.dimensionName !== 'Coupons' && dimension.dimensionParam === 'N')

    var filters = []
    dimensionsFiltered.forEach(function (category) {
      var dimensionNames = []
      category.refinements.forEach(function (item) {
        if (dimenstionList.includes(item.refinementId)) {
          dimensionNames.push(item.refinementName)
        }
      })

      if (dimensionNames.length > 0) {
        var filter = {
          'type': category.dimensionName,
          'values': dimensionNames
        }
        filters.push(filter)
      }
    })

    let dataLayer = (window.dataLayer = window.dataLayer || [])
    dataLayer.push({
      'event': 'e_vpv',
      'vpv': '/vpv/addons/search-results',
      'pageNum': currentPage,
      'filters': filters,
      'sort': state.searchParams.Ns,
      'searchTerm': data.contents.searchTerm,
      'searchResults': {
        'total': data.contents.numberOfProducts
      }
    })

    //ADDING INITIAL TRACKING ON SEARCH RESULT CHANGES
    window.setTimeout(() => {
      var products = $(".gtm-product:not(.gtm-impressed)")
      if (products.length > 0) {
        var gtmPayload = {};
        gtmPayload.event = ADDON_PRODUCT_IMPRESSION_EVENT;
        var impressions = [];

        $(products).each(function (i) {
          var inView = isInViewport(this)
          if (inView) { // only track the products in viewport
            var productData = $(this).children('script[type="application/ld+json"]').text()
            var json = JSON.parse(productData)
            impressions.push(json)
            // mark products as viewed, so they aren't picked up again in scroll event
            $(this).addClass("gtm-impressed")
          }
        })

        if (impressions.length > 0) {
          gtmPayload.ecommerce = { "impressions": impressions }
          dataLayer.push(gtmPayload)
        }
      }
    }, (1000))

    function isInViewport(elem) {
      var bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

  },
  DECREMENT_ITEM_QUANTITY(state, item) {
    item.quantity--

    // TODO use _.debounce to limit this
    this.dispatch('orderAddOns/PUT_ITEM_QUANTITY', item)
  },
  INCREMENT_ITEM_QUANTITY(state, item) {
    if (item.quantity >= 100) {
      return
    }

    item.quantity++

    // TODO use _.debounce to limit this
    this.dispatch('orderAddOns/PUT_ITEM_QUANTITY', item)
  },
  TOGGLE_ORDER_SUBSTITUTIONS(state) {
    state.orderAddOn.substitutionsAllowAll = !state.orderAddOn.substitutionsAllowAll
    this.dispatch('orderAddOns/PUT_ORDER_SUBSTITUTION', state.orderAddOn.substitutionsAllowAll)
  },
  TOGGLE_ITEM_SUBSTITUTION(state, item) {
    let commerceItem = state.orderAddOn.commerceItems[item.itemIndex]
    commerceItem.allowSubstitution = !commerceItem.allowSubstitution
    this.dispatch('orderAddOns/PUT_ITEM_SUBSTITUTION', commerceItem)
  },
  UPDATE_EXPIRATION(state, currentTime) {
    // get the current time
    if (currentTime) {
      this._vm.$set(state, 'currentTime', currentTime)
    } else {
      currentTime = state.currentTime
    }

    // get cut off time
    const { addOnCutoffTime } = state.orderAddOn

    // init with defaults
    const init = {
      in: {},
      at: addOnCutoffTime,
      isActive: false,
      isPassed: false
    }

    // set up the "expiration" property
    const cur = moment(currentTime) // if undefined, uses "now"
    const exp = moment(addOnCutoffTime) // if undefined, uses "now"

    // check `expiry` for "undefined" (not `exp`)
    const expiration = (currentTime && addOnCutoffTime) ? {
      in: {
        hours: exp.diff(cur, 'hours'),
        minutes: exp.diff(cur, 'minutes'),
        seconds: exp.diff(cur, 'seconds')
      },
      isActive: exp.isAfter(cur),
      isPassed: !exp.isAfter(cur)
    } : {}

    this._vm.$set(state, 'expiration', merge({}, init, expiration))

    // when we have an active orderAddOns session
    // update the current time & expiration at a set interval
    if (expiration.isActive) {
      const INTERVAL_SECONDS = 10

      // clear the previous timeout (so we don't update more than once during the interval)
      window.clearTimeout(state.currentTimeTimoutId)

      const newTime = moment(currentTime)
        .add(INTERVAL_SECONDS, 'seconds') // add time
        .format('YYYY-MM-DDTHH:mm:ssZZ') // this should match the "currentTime" returned from api, to be consistent

      const timeoutId = window.setTimeout(() => {
        // recursively run this update with the new time
        this.commit('orderAddOns/UPDATE_EXPIRATION', newTime)
      }, (INTERVAL_SECONDS * 1000))

      // commit the timeoutId (so if something else triggers this function, we can clear it)
      this._vm.$set(state, 'currentTimeTimeoutId', timeoutId)
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
